import React, { useMemo } from "react";
import { RCCGrid} from "react-common-components";
import Permissions from "src/components/Permissions";
import {IPermissionsTab} from "../interface";

const TabPermissions: React.FC<IPermissionsTab> = ({ 
	permissions,
	register,
	control, 
	unregister,
	errors, 
	clearErrors  
}) => {

	const PermissionsList = useMemo(() => (
		<Permissions
			register={register}
			unregister={unregister}
			control={control}
			error={errors}
			clearErrors={clearErrors}
			permissionsNames= {{
				nameObject: "permissions",
				nameOfID: "iqc005Id",
				nameOfSelectUser: "iqc005Efa005Id",
				nameOfSelectGroup: "iqc005Efa004Id",
				nameOfSelectPermission: "iqc005Permissao",
				nameOfSelectGroupDescription:"efa004Descricao",
				nameOfSelectUserDescription:"efa005Nome",
				defaultValue: permissions
			}}
			permissionType="complete"
		/>
	),[permissions,errors]);

	return(
		<RCCGrid container item justifyContent="center">
			<RCCGrid container item xs={12} sm={10} lg={8}>
				{PermissionsList}
			</RCCGrid>
		</RCCGrid>
	);
};
export default TabPermissions;

